import { FormWrapper } from "@/components/molecules/FormWrapper/FormWrapper";
import { FormSelect } from "@/components/molecules/FormSelect/FormSelect";
import { FormInput } from "@/components/molecules/FormInput/FormInput";
import { mapToFormValues } from "../infrastructure/LimitControlMapper";
import { LimitConfigFormProps } from "./LimitConfigForm.types";
import { LimitFormData, schema } from "../infrastructure/LimitControlConstants";
import { useConfirmDialogs } from "@/core/context/DialogContext";

export const LimitConfigForm = ({
    formStatus,
    limitControlSelected,
    limitTypes,
    subLimitTypes,
    denominators,
    portfolios,
    limitEvaluationOptions,
    onSubmit,
    onDelete,
    setLimitTypeSelected,
}: LimitConfigFormProps) => {
    const showDialog = useConfirmDialogs();

    const confirmDelete = async (id: string) => {
        const confirm = await showDialog({
            title: "¿Estás seguro?",
            description: "Esta acción eliminará el registro. ¿Deseas continuar?",
            variant: "delete",
        });

        if (confirm) {
            onDelete(id);
        }
    }
    console.log(subLimitTypes);

    return (
        <FormWrapper<LimitFormData>
            defaultValues={limitControlSelected ? mapToFormValues(limitControlSelected) : undefined}
            onSubmit={onSubmit}
            schema={schema}
            formStatus={formStatus}
            onDelete={confirmDelete}
        >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                <FormSelect
                    name="limitType"
                    label="Tipo de límite"
                    onChange={setLimitTypeSelected}
                    options={limitTypes}
                    resetFields={["subLimit"]}
                />
                <FormSelect name="subLimit" label="Valor límite" options={subLimitTypes} />
                <FormSelect name="limitEvaluation" label="Evaluación límite" options={limitEvaluationOptions} />
                <FormInput name="percentage" label="Porcentaje" type="number" />
                <FormSelect name="denominator" label="Denominador" options={denominators} />
                <FormSelect name="portfolio" label="Portafolio" options={portfolios} />
            </div>
        </FormWrapper>
    );
};
